import { ReactNode } from 'react'
import { Grid, Typography } from '@mui/material'

type Props = {
  title: string
  children: ReactNode
  contentPaddingTop?: number
}

export const PaperSection = ({ title, children, contentPaddingTop }: Props) => (
  <Grid container direction="column" wrap="nowrap" sx={{ marginBottom: 3, boxSizing: 'content-box' }} size={{ xs: 12 }}>
    <Grid>
      <Typography variant="h5" sx={({ palette: { grey } }) => ({ marginTop: 1, color: grey[600] })}>
        {title}
      </Typography>
    </Grid>
    <Grid container sx={({ spacing }) => ({ paddingTop: spacing(contentPaddingTop || 2) })}>
      {children}
    </Grid>
  </Grid>
)
